import { render, staticRenderFns } from "./heater.vue?vue&type=template&id=1fc10276"
import script from "./heater.vue?vue&type=script&lang=js"
export * from "./heater.vue?vue&type=script&lang=js"
import style0 from "./heater.vue?vue&type=style&index=0&id=1fc10276&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/app/components/img.vue').default,ProductDetails: require('/app/components/product/details.vue').default})
